import React from "react";
import TableButton from "../UI/TableButton";
import Timer from "../UI/Timer";

const seatingData = {
  // 1F: 矩形房間，外帶區在左上角，桌子沿著牆邊排列
  "1F": [
    { id: "1F-S1", x: 12, y: 40, size: "medium" }, // 左上角
    { id: "1F-S2", x: 12, y: 78, size: "medium" }, // 左下角
    { id: "1F-S3", x: 37, y: 78, size: "medium" }, // 2桌右邊
    { id: "1F-S4", x: 62, y: 78, size: "medium" }, // 3桌右邊
    { id: "1F-S5", x: 87, y: 78, size: "medium" }, // 最右下角
    { id: "1F-外桌", x: 62, y: 40, size: "medium" }, // 4桌上面
  ],
  // 2F: 分兩房間
  "2F": [
    // 左房間：中間1桌，三邊各1桌，總共4桌
    { id: "2F-A0", x: 25, y: 70, size: "medium" }, // 下邊牆
    { id: "2F-A1", x: 10, y: 45, size: "medium" }, // 左邊牆
    { id: "2F-A2", x: 25, y: 25, size: "medium" }, // 中央桌
    { id: "2F-A3", x: 40, y: 45, size: "medium" }, // 右邊牆

    // 右房間：4、5桌對齊，6桌是大桌
    { id: "2F-B1", x: 60, y: 45, size: "medium" }, // 右房間左側，貼牆
    { id: "2F-C1", x: 75, y: 45, size: "medium" }, // 右房間中間，與5桌對齊
    { id: "2F-翔", x: 90, y: 45, size: "medium" }, // 右房間大桌，間隔較大
  ],
};

const TakeoutPanel = ({
  takeoutOrders = [],
  timers = {},
  onTakeoutClick,
  onNewTakeout,
}) => {
  return (
    <div className="w-1/5 bg-ivory border border-warm-cream rounded-xl flex flex-col h-[605px] shadow-whisper">
      {/* 外帶標題 */}
      <div className="p-4 border-b border-warm-cream bg-parchment rounded-t-xl">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-serif text-terracotta">外帶訂單</h3>
          <button
            onClick={onNewTakeout}
            className="bg-terracotta text-ivory px-3 py-1.5 rounded-lg text-sm hover:bg-terracotta-dark transition-colors"
          >
            新增外帶
          </button>
        </div>
      </div>

      {/* 外帶訂單列表 */}
      <div className="flex-1 p-4 overflow-y-auto">
        {Object.keys(takeoutOrders).length === 0 ? (
          <div className="text-warm-stone text-center mt-8">尚無外帶訂單</div>
        ) : (
          <div className="space-y-3">
            {Object.entries(takeoutOrders).map(([takeoutId, orderData]) => {
              // 修復：計算未付款項目的總金額和數量
              const unpaidItems = (orderData.orders || []).filter(
                (item) => item && item.paid === false,
              );

              const total = unpaidItems.reduce((sum, item) => {
                // 使用完整的價格計算邏輯
                let basePrice = item.price;
                let adjustment = 0;

                if (item.selectedCustom) {
                  // 續杯折扣 -20 元
                  if (item.selectedCustom["續杯"] === "是") {
                    adjustment -= 20;
                  }

                  // 加濃縮 +20 元
                  if (item.selectedCustom["濃縮"] === "加濃縮") {
                    adjustment += 20;
                  }

                  // 換燕麥奶 +20 元
                  if (item.selectedCustom["奶"] === "換燕麥奶") {
                    adjustment += 20;
                  }
                }

                const finalPrice = Math.max(basePrice + adjustment, 0);
                return sum + finalPrice * item.quantity;
              }, 0);

              const itemCount = unpaidItems.reduce(
                (sum, item) => sum + item.quantity,
                0,
              );

              const isPaid = orderData.paid || unpaidItems.length === 0;

              return (
                <div
                  key={takeoutId}
                  onClick={() => onTakeoutClick(takeoutId)}
                  className={`p-3 rounded-lg border cursor-pointer transition-colors ${
                    isPaid
                      ? "bg-parchment border-warm-cream hover:bg-warm-sand"
                      : "bg-ivory border-terracotta-light/40 hover:bg-parchment"
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <div className="font-medium text-sm text-warm-charcoal">外帶 #{takeoutId}</div>
                    <div className="flex items-center space-x-2">
                      <Timer startTime={timers[takeoutId]} />
                      <div
                        className={`text-xs px-2 py-1 rounded ${
                          isPaid
                            ? "bg-warm-sand text-warm-charcoal"
                            : "bg-terracotta text-ivory"
                        }`}
                      >
                        {isPaid ? "已結帳" : "待結帳"}
                      </div>
                    </div>
                  </div>

                  <div className="mt-2 text-sm text-warm-olive">
                    {isPaid
                      ? `${(orderData.orders || []).length} 項商品 (已完成)`
                      : `${itemCount} 項商品`}
                  </div>

                  <div className="mt-1 font-bold text-terracotta">
                    $
                    {isPaid
                      ? (orderData.orders || []).reduce((sum, item) => {
                          let basePrice = item.price;
                          let adjustment = 0;

                          if (item.selectedCustom) {
                            // 續杯折扣 -20 元
                            if (item.selectedCustom["續杯"] === "是") {
                              adjustment -= 20;
                            }

                            // 加濃縮 +20 元
                            if (item.selectedCustom["濃縮"] === "加濃縮") {
                              adjustment += 20;
                            }

                            // 換燕麥奶 +20 元
                            if (item.selectedCustom["奶"] === "換燕麥奶") {
                              adjustment += 20;
                            }
                          }

                          const finalPrice = Math.max(
                            basePrice + adjustment,
                            0,
                          );
                          return sum + finalPrice * item.quantity;
                        }, 0)
                      : total}
                  </div>

                  <div className="mt-1 text-xs text-warm-stone">
                    {new Date(orderData.timestamp).toLocaleTimeString()}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

const SeatingArea = ({
  currentFloor,
  orders,
  takeoutOrders,
  timers,
  onTableClick,
  onTakeoutClick,
  onNewTakeout,
}) => {
  // 新增入座狀態判斷
  const getTableStatus = (tableId) => {
    const tableBatches = orders[tableId];

    if (
      !tableBatches ||
      !Array.isArray(tableBatches) ||
      tableBatches.length === 0
    ) {
      return "available";
    }

    // 檢查特殊的入座標記
    if (
      tableBatches.length === 1 &&
      tableBatches[0] &&
      tableBatches[0].__seated_only
    ) {
      return "seated";
    }

    // 其他狀態檢查...
    let hasUnpaidItems = false;
    let hasPaidItems = false;

    tableBatches.forEach((batch) => {
      if (Array.isArray(batch)) {
        batch.forEach((item) => {
          if (item && typeof item === "object" && !item.__seated) {
            if (item.paid === false) hasUnpaidItems = true;
            else if (item.paid === true) hasPaidItems = true;
          }
        });
      }
    });

    if (hasUnpaidItems) return "occupied";
    if (hasPaidItems) return "ready-to-clean";
    return "available";
  };

  // 根據樓層決定容器樣式
  const getContainerStyle = () => {
    if (currentFloor === "1F") {
      // 1F: 左側座位區 + 右側外帶區
      return {
        containerClass: "flex",
        seatingClass:
          "flex-1 bg-ivory rounded-xl shadow-whisper h-[605px] relative border border-warm-cream mr-8",
      };
    } else {
      // 2F: 只有座位區
      return {
        containerClass: "flex",
        seatingClass:
          "flex-1 bg-ivory rounded-xl shadow-whisper h-[620px] relative border border-warm-cream",
      };
    }
  };

  const { containerClass, seatingClass } = getContainerStyle();

  return (
    <div className="relative px-6 flex-1 flex flex-col">
      {/* 2F 區域分隔線 */}
      {currentFloor === "2F" && (
        <div
          className="absolute top-0 left-1/2 w-0.5 h-[620px] bg-warm-sand"
          style={{ zIndex: 10 }}
        ></div>
      )}
      <div className={containerClass + " flex-1 flex"}>
        {/* 座位區域 */}
        <div className={seatingClass} style={{ overflowY: "auto" }}>
          <div className="relative w-full h-[600px] bg-ivory rounded-xl">
            {/* 這裡渲染所有 TableButton */}
            {seatingData[currentFloor].map((table) => (
              <TableButton
                key={table.id}
                table={table}
                status={getTableStatus(table.id)}
                onClick={onTableClick}
                startTime={timers[table.id]}
              />
            ))}
          </div>
        </div>

        {/* 外帶面板（只在 1F 顯示） */}
        {currentFloor === "1F" && (
          <TakeoutPanel
            takeoutOrders={takeoutOrders}
            timers={timers}
            onTakeoutClick={onTakeoutClick}
            onNewTakeout={onNewTakeout}
          />
        )}
      </div>

      {/* 圖例：新增入座 */}
      <div
        className="absolute left-0 bottom-0 w-full flex justify-center space-x-6 bg-parchment py-8"
        style={{ zIndex: 20 }}
      >
        <div className="flex items-center space-x-2">
          <div className="w-4 h-4 bg-warm-sand border border-warm-cream rounded-full"></div>
          <span className="text-sm text-warm-olive">空桌</span>
        </div>
        <div className="flex items-center space-x-2">
          <div className="w-4 h-4 bg-terracotta-light/30 border border-terracotta-light rounded-full"></div>
          <span className="text-sm text-warm-olive">入座</span>
        </div>
        <div className="flex items-center space-x-2">
          <div className="w-4 h-4 bg-terracotta/70 border border-terracotta rounded-full"></div>
          <span className="text-sm text-warm-olive">用餐中</span>
        </div>
        <div className="flex items-center space-x-2">
          <div className="w-4 h-4 bg-warm-charcoal/30 border border-warm-olive rounded-full animate-pulse"></div>
          <span className="text-sm text-warm-olive">待清理</span>
        </div>
      </div>
    </div>
  );
};

export { seatingData };
export default SeatingArea;
